import { LoginPageLoading } from 'components/loginPage/LoginPageLoading';
import Cookies from 'js-cookie';
import { useQuery } from 'pages/useQuery';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { decodeOurJWT } from 'components/accessControl/decodeOurJWT';
import { getDefaultHomeLinkForUserType } from 'components/accessControl/getDefaultHomeLinkForUserType';
import { userTypeCookieName } from 'ui-toolkit/authentication/data/userTypeCookieName';
import { createAuth0ClientForSpruce } from 'ui-toolkit/authentication/methods/createAuth0ClientForSpruce';
import { getAuth0ClientTypeFromUserType } from 'ui-toolkit/authentication/methods/getAuth0ClientTypeFromUserType';
import { eAuth0ClientType } from 'ui-toolkit/authentication/types/eAuth0ClientType';
import { eAccessControlLogoutReason } from 'ui-toolkit/enums/eAccessControlLogoutReason';
import { ClientUrlFactory } from '../../ui-toolkit/rest/ClientUrlFactory';
import { shouldAllowThisRedirect } from './shouldAllowThisRedirect';
import { useGetConfigQuery } from 'API/applicationConfig/ApplicationConfigAPI';
import {
  jwtCookieName,
  setLatestActivityTime,
  spruceClaimsFieldName,
} from 'types/accessControl/AccessControlConstants';
import { eAccessControlUserType } from '../../ui-toolkit/enums/eAccessControlUserType';

const MILLISECONDS_PER_SECOND = 1000;

export const Auth0LoginRouterContainer: React.FC = () => {
  const [auth0ClientType, setAuthClientType] = React.useState<eAuth0ClientType>();
  const [userType, setUserType] = React.useState<eAccessControlUserType>();
  const [token, setToken] = React.useState<string>();
  const { data: authConfig } = useGetConfigQuery();
  const history = useHistory();
  const query = useQuery();

  useEffect(() => {
    const userType = Cookies.get(userTypeCookieName) as eAccessControlUserType;
    if (userType) {
      setUserType(userType);
      setAuthClientType(getAuth0ClientTypeFromUserType(userType));
    }
  }, [setAuthClientType]);
  useEffect(() => {
    const validExecutionCondtion = authConfig && auth0ClientType && userType;

    if (!validExecutionCondtion) return;

    const auth0ClientConfig = authConfig.loginConfigurations[auth0ClientType];
    const auth0Client = createAuth0ClientForSpruce(auth0ClientConfig, userType);
    auth0Client.then(async (client) => {
      await client.handleRedirectCallback();
      const token = await client.getTokenSilently();
      setToken(token);
    });
  }, [auth0ClientType, authConfig, userType]);
  useEffect(() => {
    if (!token) return;

    const decoded = decodeOurJWT(token);
    if (!decoded[spruceClaimsFieldName]?.sid) {
      if (userType === eAccessControlUserType.Admin) {
        window.location.href = ClientUrlFactory().urlFor.logoutAuth0(eAccessControlLogoutReason.ADMIN_REDIRECT);
      } else {
        throw new Error(`User Does not have correct JWT claims`);
      }
    } else {
      Cookies.set(jwtCookieName, token, {
        expires: new Date(decoded.exp * MILLISECONDS_PER_SECOND),
        secure: true,
        sameSite: 'strict',
      });
      setLatestActivityTime();
      const url = getDefaultHomeLinkForUserType(userType ?? eAccessControlUserType.None);
      const redirectTo = query.get('redirect_to');
      if (redirectTo && shouldAllowThisRedirect(redirectTo)) {
        history.push(redirectTo);
      } else {
        history.push(url);
      }
    }
  }, [token, history, query, userType]);

  return <LoginPageLoading />;
};
